import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";
import { DirectorsBoardMember } from "../../../../../types";

interface DirectorNameInputProps {
  member: DirectorsBoardMember;
  onChange: ({ key, value }: { key: string; value: string }) => void;
}

export const DirectorNameInput = (props: DirectorNameInputProps) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const { form, isBusy } = implementerAccountContext;
  const { getFieldDecorator } = form;
  const { member, onChange } = props;

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ value: event.target.value, key: "name" });
  };

  return (
    <Form.Item label="Nombre">
      {getFieldDecorator(`directorName.${props.member.id}`, {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el nombre."
          }
        ],
        initialValue: member?.name
      })(
        <Input
          disabled={isBusy}
          id={`directorName-${member.id}`}
          name="directorName"
          placeholder="Nombre"
          onChange={handleOnChange}
          size="large" />
      )}
    </Form.Item>
  );
};
